import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSettingsParameters = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.3535 4.75H3C2.58579 4.75 2.25 5.08579 2.25 5.5C2.25 5.91421 2.58579 6.25 3 6.25H14.3535C14.68 7.40425 15.7412 8.25 17 8.25C18.2588 8.25 19.32 7.40425 19.6465 6.25H21C21.4142 6.25 21.75 5.91421 21.75 5.5C21.75 5.08579 21.4142 4.75 21 4.75H19.6465C19.32 3.59575 18.2588 2.75 17 2.75C15.7412 2.75 14.68 3.59575 14.3535 4.75ZM15.75 5.5C15.75 4.80964 16.3096 4.25 17 4.25C17.6904 4.25 18.25 4.80964 18.25 5.5C18.25 6.19036 17.6904 6.75 17 6.75C16.3096 6.75 15.75 6.19036 15.75 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 18.5C2.25 18.0858 2.58579 17.75 3 17.75H14.3535C14.68 16.5957 15.7412 15.75 17 15.75C18.2588 15.75 19.32 16.5957 19.6465 17.75H21C21.4142 17.75 21.75 18.0858 21.75 18.5C21.75 18.9142 21.4142 19.25 21 19.25H19.6465C19.32 20.4043 18.2588 21.25 17 21.25C15.7412 21.25 14.68 20.4043 14.3535 19.25H3C2.58579 19.25 2.25 18.9142 2.25 18.5ZM17 17.25C17.6904 17.25 18.25 17.8096 18.25 18.5C18.25 19.1904 17.6904 19.75 17 19.75C16.3096 19.75 15.75 19.1904 15.75 18.5C15.75 17.8096 16.3096 17.25 17 17.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H9.64648C9.32002 13.9043 8.25878 14.75 7 14.75C5.74122 14.75 4.67998 13.9043 4.35352 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H4.35352C4.67998 10.0957 5.74122 9.25 7 9.25C8.25878 9.25 9.32002 10.0957 9.64648 11.25H21ZM5.75 12C5.75 12.6904 6.30964 13.25 7 13.25C7.69036 13.25 8.25 12.6904 8.25 12C8.25 11.3096 7.69036 10.75 7 10.75C6.30964 10.75 5.75 11.3096 5.75 12Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconSettingsParameters as ReactComponent };
